var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNoteAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 50a40 40 0 1080 0 40 40 0 10-80 0z",
    fill: "#D9EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.235 30.027H63.72v35.28H26.235z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.235 30.027H63.72v35.28H26.235z",
    fill: "none",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.607 33.886a1.654 1.654 0 11-3.308 0v-8.269a1.654 1.654 0 013.308 0z",
    fill: "#B0D9FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35.607 33.886a1.654 1.654 0 11-3.308 0v-8.269a1.654 1.654 0 013.308 0z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M46.632 33.886a1.654 1.654 0 11-3.308 0v-8.269a1.654 1.654 0 013.308 0z",
    fill: "#B0D9FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.632 33.886a1.654 1.654 0 11-3.308 0v-8.269a1.654 1.654 0 013.308 0z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.657 33.886a1.654 1.654 0 11-3.308 0v-8.269a1.654 1.654 0 013.308 0z",
    fill: "#B0D9FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57.657 33.886a1.654 1.654 0 11-3.308 0v-8.269a1.654 1.654 0 013.308 0z",
    fill: "#B0D9FF",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M26.985 74.167a18.191 2.205 0 1036.382 0 18.191 2.205 0 10-36.382 0z",
    fill: "#B0D9FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.132 72.541a2.255 2.255 0 01-1.99-3.316l14.283-26.779a2.255 2.255 0 013.979 0l14.283 26.779a2.254 2.254 0 01-1.99 3.316z",
    fill: "#B0D9FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.132 72.541a2.255 2.255 0 01-1.99-3.316l14.283-26.779a2.255 2.255 0 013.979 0l14.283 26.779a2.254 2.254 0 01-1.99 3.316z",
    fill: "none",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M68.949 61.905a.551.551 0 01-1.069 0c-2.157-8.5-2.067-8.12-2.075-8.206a2.621 2.621 0 115.219 0c-.008.086.083-.299-2.075 8.206z",
    fill: "#fff",
    stroke: "#020064",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M68.414 69.075a2.122 2.122 0 112.122-2.122 2.124 2.124 0 01-2.122 2.122z",
    fill: "#fff"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.414 65.332a1.622 1.622 0 11-1.62 1.621 1.623 1.623 0 011.62-1.621m0-1a2.622 2.622 0 102.622 2.621 2.621 2.621 0 00-2.622-2.621z",
    fill: "#020064"
  })));
}

export default SvgNoteAlert;